module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0110.jpg?v=8d7c7a4a";